<template>
  <b-row>
    <b-col
      md="12"
      lg="12"
      class="filter-heading"
    >
      <h4>{{ $t('DEBTIA_CASE_FILTERS') }}</h4>
      <b-alert
        v-if="caseAllowedFilters.length < 1"
        variant="warning"
        show
      >
        <div class="alert-body">
          <span>{{ $t('DEBTIA_NO_FILTER_SELECTED') }}!</span>
        </div>
      </b-alert>
    </b-col>
    <b-col
      v-if="caseAllowedFilters.indexOf('processes') > -1"
      md="6"
      lg="6"
    >
      <validation-provider
        #default="{ errors }"
        name="Process(es)"
        rules="required"
      >
        <b-form-group
          :label="$t('DEBTIA_PROCESSES')"
          label-for="processId"
        >
          <v-select
            v-model="caseFiltersValues.processes"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="[{ label: $t('DEBTIA_DEBT_CASE_ACTIVE_PROCESS') , value: 0 }, ...processes]"
            :reduce="val => val.value"
            :clearable="false"
            multiple
            input-id="processId"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </b-form-group>
      </validation-provider>
    </b-col>
    <b-col
      v-if="caseAllowedFilters.indexOf('status') > -1"
      md="6"
      lg="6"
    >
      <validation-provider
        #default="{ errors }"
        name="Status"
        rules="required"
      >
        <b-form-group
          :label="$t('DEBTIA_STATUS')"
          label-for="status"
        >
          <v-select
            v-model="caseFiltersValues.status"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="[{label: $t('DEBTIA_ACCEPTED'), value: 1}, {label: $t('DEBTIA_DECLINED'), value: 2}, {label: $t('DEBTIA_TERMINATED') , value: 3}, {label: $t('DEBTIA_PAUSED') , value: 4}]"
            :reduce="val => val.value"
            :clearable="false"
            multiple
            input-id="caseState"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </b-form-group>
      </validation-provider>
    </b-col>
    <date-field
      v-if="caseAllowedFilters.indexOf('creation_date') > -1"
      :label="'DEBTIA_CREATION_DATE'"
      :label-for="'creation_date'"
      :case-allowed-filters="caseAllowedFilters"
      :date-values="caseFiltersValues.creation_date"
    />
    <date-field
      v-if="caseAllowedFilters.indexOf('current_process_date') > -1"
      :label="'DEBTIA_CURRENT_PROCESS_ENTER_DATE'"
      :label-for="'current_process_date'"
      :case-allowed-filters="caseAllowedFilters"
      :date-values="caseFiltersValues.current_process_date"
    />
    <b-col
      v-if="caseAllowedFilters.indexOf('client_ids') > -1 "
      md="6"
      lg="6"
    >
      <validation-provider
        #default="{ errors }"
        name="Client(s)"
        rules="required"
      >
        <b-form-group
          :label="$t('DEBTIA_CLIENTS')"
          label-for="Clients"
        >
          <v-select
            v-model="caseFiltersValues.client_ids"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="clientsOptions"
            :reduce="val => val.value"
            :clearable="false"
            multiple
            input-id="clients"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </b-form-group>
      </validation-provider>
    </b-col>
    <b-col
      v-if="caseAllowedFilters.indexOf('debtors_ids') > -1"
      md="6"
      lg="6"
    >
      <validation-provider
        #default="{ errors }"
        name="Debtor(s)"
        rules="required"
      >
        <b-form-group
          :label="$t('DEBTIA_DEBTORS')"
          label-for="Debtor(s)"
        >
          <v-select
            v-model="caseFiltersValues.debtors_ids"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="debtors"
            :reduce="val => val.value"
            :clearable="false"
            multiple
            input-id="debtors"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </b-form-group>
      </validation-provider>
    </b-col>
    <b-col
      v-if="caseAllowedFilters.indexOf('case_groups') > -1 "
      md="6"
      lg="6"
    >
      <validation-provider
        #default="{ errors }"
        name="Case Groups"
        rules="required"
      >
        <b-form-group
          :label="$t('DEBTIA_CASEGROUPS')"
          label-for="Case Groups"
        >
          <v-select
            v-model="caseFiltersValues.case_groups"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="caseGroups"
            :reduce="val => val.value"
            :clearable="false"
            multiple
            input-id="casegroups"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </b-form-group>
      </validation-provider>
    </b-col>
    <b-col
      v-if="caseAllowedFilters.indexOf('custom_fields') > -1"
      md="6"
      lg="6"
    >
      <validation-provider
        #default="{ errors }"
        name="Custom Field(s)"
        rules="required"
      >
        <b-form-group
          :label="$t('DEBTIA_CUSTOM_FIELDS')"
          label-for="Custom Fields"
        >
          <v-select
            v-model="customFields"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="customVariables"
            :reduce="val => val.value"
            :clearable="false"
            multiple
            input-id="Custom Fields"
            @option:deselected="customVariableChange($event, 0)"
            @option:selected="customVariableChange($event, 1)"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </b-form-group>
      </validation-provider>
    </b-col>
    <b-col
      v-if="caseAllowedFilters.indexOf('custom_fields') > -1 && caseFiltersValues.custom_fields.length > 0"
      md="12"
      lg="12"
    >
      <fields-file
        :custom-variables="caseFiltersValues.custom_fields"
        :airports="airports"
      />
    </b-col>
    <b-col
      v-if="caseAllowedFilters.indexOf('fileTypes') > -1"
      md="6"
      lg="6"
      class="mt-1"
    >
      <validation-provider
        #default="{ errors }"
        name="File Type(s)"
        rules="required"
      >
        <b-form-group
          :label="$t('DEBTIA_FILETYPES')"
          label-for="File Types"
        >
          <v-select
            v-model="caseFiltersValues.fileTypes"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="categoryOptions"
            :reduce="val => val.value"
            :clearable="false"
            multiple
            input-id="File Types"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </b-form-group>
      </validation-provider>
    </b-col>
    <b-col
      v-if="caseAllowedFilters.indexOf('statements') > -1"
      md="6"
      lg="6"
    >
      <b-form-group
        :label="$t('DEBTIA_STATEMENTS')"
        label-for="Statements"
        label-cols-md="3"
      >
        <validation-provider
          #default="{ errors }"
          name="Statements"
          rules="required"
        >
          <v-select
            v-model="caseFiltersValues.statements.statement_keys"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="statements"
            :reduce="val => val.value"
            :clearable="false"
            multiple
            input-id="Statements"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
      <b-form-group>
        <b-form-radio-group
          v-model="caseFiltersValues.statements.statements_comparison_type"
          :options="numberComparisonOptions"
          class="demo-inline-spacing margin-botton-3"
          value-field="value"
          text-field="text"
          disabled-field="disabled"
        />
        <b-input-group
          v-if="caseFiltersValues.statements.statements_comparison_type && caseFiltersValues.statements.statements_comparison_type !== '<>'"
          class="input-group-merge"
        >
          <b-input-group-prepend is-text>
            {{ $t('DEBTIA_STATEMENTS') }} {{ caseFiltersValues.statements.statements_comparison_type === '=' ? $t('DEBTIA_EQUALS_TO')+' ' : caseFiltersValues.statements.statements_comparison_type === '>' ? ' '+$t('DEBTIA_GREATER_THAN') : ' '+$t('DEBTIA_LESS_THAN')+' ' }}
          </b-input-group-prepend>
          <b-form-input
            v-model="caseFiltersValues.statements.statement_second_value"
            :placeholder="$t('DEBTIA_STATEMENTS')"
          />
        </b-input-group>
        <b-input-group
          v-else-if="caseFiltersValues.statements.statements_comparison_type && caseFiltersValues.statements.statements_comparison_type === '<>'"
          class="input-group-merge"
        >
          <b-input-group-prepend is-text>
            {{ $t('DEBTIA_FROM') }}
          </b-input-group-prepend>
          <b-form-input
            v-model="caseFiltersValues.statements.statement_first_value"
            :placeholder="$t('DEBTIA_STATEMENTS')"
          />
          <b-input-group-prepend is-text>
            {{ $t('DEBTIA_TILL') }}
          </b-input-group-prepend>
          <b-form-input
            v-model="caseFiltersValues.statements.statement_second_value"
            :placeholder="$t('DEBTIA_STATEMENTS')"
          />
        </b-input-group>
        <b-form-input
          v-else
          placeholder="Select Operation"
          disabled
        />
        <validation-provider
          #default="{ errors }"
          name=" "
          rules="required"
        >
          <small
            class="text-danger"
          >{{ errors[0] }}</small>
          <b-form-input
            v-model="numberOfStatement"
            style="display: none;"
            disabled
          />
        </validation-provider>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BAlert, BFormInput, BInputGroup, BFormRadioGroup, BInputGroupPrepend,
  // BInputGroupPrepend,
} from 'bootstrap-vue'
// import vSelect from 'vue-select'
import axios from '@axios'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import vSelect from 'vue-select'
import DateField from './DateField.vue'
import FieldsFile from './customfields/FieldsFile.vue'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    ValidationProvider,
    vSelect,
    // BInputGroupPrepend,
    DateField,
    BAlert,
    FieldsFile,
    BInputGroup,
    BFormInput,
    BFormRadioGroup,
    BInputGroupPrepend,
  },
  directives: {
    Ripple,
  },
  props: {
    filterId: {
      type: Number,
      required: true,
    },
    filterValue: {
      type: String,
      required: true,
    },
    filterBit: {
      type: Boolean,
      required: true,
    },
    filterDetails: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      required,
      customFields: [],
      caseAllowedFilters: [],
      caseFiltersValues: {
        processes: [],
        status: [],
        creation_date: {
          is_dynamic: false,
          // creation_fieldValue: null,
          no_of_days: null,
          from_date: {
            is_dynamic: false,
            no_of_days: null,
            value: null,
          },
          till_date: {
            is_dynamic: false,
            no_of_days: null,
            value: null,
          },
          value: null,
        },
        current_process_date: {
          is_dynamic: false,
          // creation_fieldValue: null,
          no_of_days: null,
          from_date: {
            is_dynamic: false,
            no_of_days: null,
            value: null,
          },
          till_date: {
            is_dynamic: false,
            no_of_days: null,
            value: null,
          },
          value: null,
        },
        client_ids: [],
        debtors_ids: [],
        case_groups: [],
        custom_fields: [],
        fileTypes: [],
        statements: {
          statement_keys: [],
          statements_comparison_type: null,
          statement_first_value: null,
          statement_second_value: null,
        },
      },
      processes: [],
      caseGroups: [],
      customVariables: [],
      categoryOptions: [],
      debtors: [],
      clientsOptions: [],
      airports: [],
      statements: [],
      firstCreationDateLoad: true,
      firstProcessDateLoad: true,
      numberComparisonOptions: [
        { text: 'Greater Than', value: '>', disabled: false },
        { text: 'Less Than', value: '<', disabled: false },
        { html: 'Equals to', value: '=', disabled: false },
        { text: 'Between', value: '<>', disabled: false },
      ],
      numberOfStatement: null,
      firstLoad: true,
    }
  },
  watch: {
    filterBit: {
      handler() {
        this.filterChange()
      },
    },
    'caseFiltersValues.statements.statements_comparison_type': {
      handler() {
        if (!this.firstLoad) {
          this.caseFiltersValues.statements.statement_first_value = null
          this.caseFiltersValues.statements.statement_second_value = null
        }
        if (this.firstLoad) this.firstLoad = false
      },
    },
    'caseFiltersValues.statements.statement_first_value': {
      handler() {
        this.checkCaseValidity(this.caseFiltersValues.statements)
      },
    },
    'caseFiltersValues.statements.statement_second_value': {
      handler() {
        this.checkCaseValidity(this.caseFiltersValues.statements)
      },
    },
  },
  created() {
    this.getProcesses()
    this.getCaseGroups()
    this.getCategoryOptions()
    this.getDebtors()
    this.getClients()
    this.getCustomVariables()
    this.getStatements()
    if (this.filterId) this.changeCaseFiltersValues()
    this.caseAllowedFilters = Object.keys(this.filterDetails)
    if (this.filterDetails.custom_fields) this.mapCustomVariableValues()
  },
  methods: {
    mapCustomVariableValues() {
      this.caseFiltersValues.custom_fields = this.filterDetails.custom_fields
      this.customFields = this.filterDetails.custom_fields.map(x => Number(x.id))
    },
    getStatements() {
      const url = '/settings/get-statements-dropdown'
      axios.get(url).then(response => {
        if (response.status === 200) {
          this.statements = response.data.data
        }
      })
    },
    customVariableChange(event, added) {
      if (added) {
        const customField = event[event.length - 1]
        const obj = {
          id: customField.value,
          data: {
            type: customField.type,
            label: customField.label,
            options: customField.options,
            value: null,
          },
        }
        this.caseFiltersValues.custom_fields.push(obj)
      } else {
        this.caseFiltersValues.custom_fields
          .splice(this.caseFiltersValues.custom_fields
            .indexOf(this.caseFiltersValues.custom_fields
              .filter(element => element.id === event.value)[0]),
          1)
      }
    },
    getCustomVariables() {
      const url = '/user-settings/custom-variables-dropdown?type=case'
      axios.get(url).then(response => {
        if (response.status === 200) {
          this.customVariables = response.data.data.variables
          this.airports = response.data.data.options
        }
      })
    },
    changeCaseFiltersValues() {
      if (this.filterDetails.processes) {
        this.caseFiltersValues.processes = this.filterDetails.processes.map(x => Number(x))
      }
      if (this.filterDetails.debtors_ids) {
        this.caseFiltersValues.debtors_ids = this.filterDetails.debtors_ids.map(x => Number(x))
      }
      if (this.filterDetails.client_ids) {
        this.caseFiltersValues.client_ids = this.filterDetails.client_ids.map(x => Number(x))
      }
      if (this.filterDetails.case_groups) {
        this.caseFiltersValues.case_groups = this.filterDetails.case_groups.map(x => Number(x))
      }
      if (this.filterDetails.status) {
        this.caseFiltersValues.status = this.filterDetails.status.map(x => Number(x))
      }
      if (this.filterDetails.fileTypes) {
        this.caseFiltersValues.fileTypes = this.filterDetails.fileTypes.map(x => Number(x))
      }
      if (this.filterDetails.creation_date) {
        if (this.filterDetails.creation_date.is_dynamic) {
          this.caseFiltersValues.creation_date.is_dynamic = this.filterDetails.creation_date.is_dynamic
          this.caseFiltersValues.creation_date.no_of_days = this.filterDetails.creation_date.no_of_days
        } else {
          this.caseFiltersValues.creation_date = this.filterDetails.creation_date
        }
      }
      if (this.filterDetails.current_process_date) {
        // this.caseFiltersValues.current_process_date = this.filterDetails.current_process_date
        if (this.filterDetails.current_process_date.is_dynamic) {
          this.caseFiltersValues.current_process_date.is_dynamic = this.filterDetails.current_process_date.is_dynamic
          this.caseFiltersValues.current_process_date.no_of_days = this.filterDetails.current_process_date.no_of_days
        } else {
          this.caseFiltersValues.current_process_date = this.filterDetails.current_process_date
        }
      }
      if (this.filterDetails.statements) {
        this.caseFiltersValues.statements.statement_keys = this.filterDetails.statements.statement_keys
        this.caseFiltersValues.statements.statements_comparison_type = this.filterDetails.statements.statements_comparison_type
        this.caseFiltersValues.statements.statement_second_value = this.filterDetails.statements.statement_second_value
        this.caseFiltersValues.statements.statement_first_value = this.filterDetails.statements.statement_first_value ? this.filterDetails.statements.statement_first_value : null
      }
    },
    filterChange() {
      const index = this.caseAllowedFilters.indexOf(this.filterValue)
      if (index < 0) {
        this.caseAllowedFilters.push(this.filterValue)
      } else {
        const arrayTypeObjects = ['processes', 'status', 'client_ids', 'debtors_ids', 'case_groups', 'custom_fields', 'fileTypes', 'statements']
        this.caseAllowedFilters.splice(this.caseAllowedFilters.indexOf(this.filterValue), 1)
        if (arrayTypeObjects.indexOf(this.filterValue) > -1) {
          this.caseFiltersValues[this.filterValue] = []
        }
      }
    },
    getClients() {
      const url = '/clients/dropdown'
      axios.get(url).then(response => {
        if (response.status === 200) {
          const clients = response.data.data
          this.clientsOptions = clients
        }
      })
    },
    getDebtors() {
      const url = '/debtor/get-user-debtors-dropdown'
      axios.get(url).then(response => {
        if (response.status === 200) {
          const debtors = response.data.data
          this.debtors = debtors
        }
      })
    },
    async getProcesses() {
      const url = '/process/get-processes-dropdown'
      await axios.get(url).then(response => {
        if (response.status === 200) {
          this.processes = response.data.data.processes
        }
      })
    },
    async getCaseGroups() {
      const url = '/debt-case-groups-dropdown'
      await axios.get(url).then(response => {
        if (response.status === 200) {
          this.caseGroups = response.data.data
        }
      })
    },
    getCategoryOptions() {
      const url = '/settings/file-categories-dropdown'
      axios.get(url).then(response => {
        if (response.status === 200) {
          this.categoryOptions = response.data.data
        }
      })
    },
    checkCaseValidity(obj) {
      let symbol = null
      let fromStatement = null
      let tillStatement = null
      this.numberOfStatement = null
      symbol = obj.statements_comparison_type
      fromStatement = obj.statement_first_value
      tillStatement = obj.statement_second_value
      if ((symbol === '<>' && fromStatement && tillStatement) || (symbol !== '<>' && tillStatement)) {
        this.numberOfStatement = tillStatement
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
